<template>
  <a-card :bordered="false" :title="type==1?'批量加价':'批量减价'">
    <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                  :label-col="currentFormLayout.labelCol"
                  :wrapper-col="currentFormLayout.wrapperCol">
      <a-form-model-item label="选择飞猪店铺" prop="authId">
        <a-select v-model="ruleForm.authId" placeholder="请选择" style="max-width: 400px" @change="changeShop">
          <a-select-option v-for="item in selectShopList" :value="item.authId" :key="item.authId">
            {{ item.taoBaoUserNick }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="指定商品">
        <a-button :disabled="proIdStr!=null" @click="showModal">点击选择</a-button>
        <span class="line-text"
              v-if="ruleForm.proIds&&ruleForm.proIds.length>0">产品ID：{{ ruleForm.proIds.join(',') }}</span>
      </a-form-model-item>
      <a-form-model-item label="价格区间" style="margin-bottom: 0">
        <a-form-model-item style="display: inline-block" prop="priceMin">
          <a-input v-model="ruleForm.priceMin" style="width: 150px;" placeholder="0">
            <span slot="addonAfter">元</span>
          </a-input>
        </a-form-model-item>
        <span style="margin: 0 10px;">至</span>
        <a-form-model-item style="display: inline-block" prop="priceMax">
          <a-input v-model="ruleForm.priceMax" style="width: 150px;" placeholder="0.01起">
            <span slot="addonAfter">元</span>
          </a-input>
        </a-form-model-item>
      </a-form-model-item>
      <a-form-model-item :label="type==1?'加价':'减价'" required style="margin-bottom: 0">
        <a-form-model-item style="display: inline-block" prop="modifyPricePercent">
          <a-input v-model="ruleForm.modifyPricePercent" style="max-width: 150px;" placeholder="0">
            <span slot="addonAfter">%</span>
          </a-input>
        </a-form-model-item>
        <a-icon type="plus" style="margin: 0 10px;"></a-icon>
        <a-form-model-item style="display: inline-block" prop="modifyPriceNum">
          <a-input v-model="ruleForm.modifyPriceNum" style="max-width: 150px;" placeholder="0">
            <span slot="addonAfter">元</span>
          </a-input>
          <span class="line-text"
                v-if="type==0">减价后的飞猪销售价不可低于本系统分销员的销售结算价，否则减价不生效</span>
        </a-form-model-item>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="primary" @click="onSubmit" :loading="submitLoading">提交并同步</a-button>
        <a-button style="margin-left: 10px;" @click="resetForm">取消</a-button>
      </a-form-model-item>
    </a-form-model>
    <selected-product-dialog
      :show="visible"
      ref="pageList"
      :itemNames="['search_proName','search_proCate']"
      :query-params="selectedQueryParams"
      :requestPromise="loadPromise"
      row-key="proId"
      @close="visible = false"
      :columns="getGoodsColumns()"
      :rowSelection="{ selectedRowKeys: selectedDialogRowKeys, onChange: onSelectDialogChange }"
    >
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <a-form-item label="商品分类" slot="search_proCate" v-bind="currentDialogLayout">
        <a-select v-model="selectedQueryParams.proType" placeholder="请选择" style="width: 100%">
          <a-select-option v-for="item in proTypeList" :value="item.code" :key="item.code">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <div slot="footer" class="btns-bottom">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" class="ml10" @click="onSelectedResult">确定</a-button>
      </div>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import fliggyMixins from './fliggyMixins'

export default {
  name: 'BatchAddOnSale',
  mixins: [ruleFormMixins, fliggyMixins],
  components: {
    SelectedProductDialog
  },
  data() {
    return {
      type: this.$route.query.type,
      proIdStr: this.$route.query.proIdStr ? this.$route.query.proIdStr : null,
      selectShopStr: this.$route.query.selectShopStr ? this.$route.query.selectShopStr : null,
      submitLoading: false,
      selectShopList: [],
      ruleForm: {
        modifyType: this.$route.query.type,//调整类型 0减价 1加价
        priceMin: '',//区间-最小
        priceMax: '',//区间-最大
        proIds: [],//商品id
        modifyPricePercent: '',//调整百分比
        modifyPriceNum: '',//调整加减价
        authId: undefined,//淘宝店铺id
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      visible: false,
      rules: {
        authId: [
          { required: true, message: '请选择飞猪店铺', trigger: 'change' }
        ],
        priceMin: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '金额有误', trigger: 'blur' },
          { validator: this.checkPrice, trigger: 'blur' }
        ],
        priceMax: [
          { pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/, message: '金额有误', trigger: 'blur' },
          { validator: this.checkMaxPrice, trigger: 'blur' }
        ],
        modifyPricePercent: [
          { pattern: /^(100|(([1-9]){1}[0-9]?|0{1})((\.)([0-9]){1,2})?)$/, message: '百分比有误', trigger: 'blur' }
        ],
        modifyPriceNum: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '金额有误', trigger: 'blur' },
          { validator: this.checkPrice, trigger: 'blur' }
        ]
      },
      selectedQueryParams: {
        proType: undefined,
        proName: '',
        authId: '',
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      selectedDialogRowKeys: [],
      loadPromise: params => this.getListPromise(params)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getData()
    })
  },
  methods: {
    getData() {
      if (this.proIdStr) {
        this.ruleForm.proIds = this.proIdStr.split(',')
        this.selectShopList = JSON.parse(this.selectShopStr)
      } else {
        this.getShopList()
      }
    },
    //获取飞猪店铺
    getShopList() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        state: 1,
        limitDto: {
          pageNum: 1,
          pageSize: 1000
        }
      }
      this.getHttpServices().getServerApiService().post('feizhu/link/queryMerchantAuthList', params)
        .then(res => {
          this.getLogUtils().logWithTag('getShopList', res)
          if (res && res.data && res.data.length > 0) {
            this.selectShopList = res.data
          }
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    checkPrice(rule, value, callback) {
      if (Number(value) > 10000) {
        callback(new Error('最大金额10000'))
      } else {
        callback()
      }
    },
    checkMaxPrice(rule, value, callback) {
      if (value) {
        if (Number(value) > 10000) {
          callback(new Error('最大金额10000'))
        } else if (Number(value) <= Number(this.ruleForm.priceMin)) {
          callback(new Error('必须大于最小值'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    //表格数据
    getListPromise(params) {
      params.authId = this.ruleForm.authId
      return this.getHttpServices().getServerApiService().post('feizhu/taobao/querySyncProList', params)
    },
    getGoodsColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '60%'
        },
        {
          title: '商品类型',
          dataIndex: 'proTypeName'
        }
      ]
    },
    showModal() {
      if (this.ruleForm.authId) {
        this.visible = true
        this.selectedDialogRowKeys = []
        this.ruleForm.proIds = []
      } else {
        this.$message.error('选择飞猪店铺')
      }
    },
    onCancel() {
      this.visible = false
    },
    changeShop(id) {
      this.getLogUtils().logWithTag('changeShop', id)
      if (!this.selectShopStr) {
        this.ruleForm.proIds = []
      }
    },
    onSelectedResult() {
      if (this.selectedDialogRowKeys && this.selectedDialogRowKeys.length > 0) {
        this.ruleForm.proIds = this.selectedDialogRowKeys
        this.onCancel()
      } else {
        this.$message.error('请选择商品')
      }
    },
    onSelectDialogChange(selectedRowKeys, selectedRows) {
      this.selectedDialogRowKeys = selectedRowKeys
      this.getLogUtils().logWithTag('selectedRowKeys', this.selectedDialogRowKeys)
    },
    checkForm() {
      if (!this.ruleForm.modifyPricePercent && !this.ruleForm.modifyPriceNum) {
        this.$message.error('加价百分比及具体金额二选一')
        return false
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('submitData', params)
      this.getHttpServices().getServerApiService().post('feizhu/link/pushPriceModify', params)
        .then(res => {
          if (res) {
            this.$message.success(res)
          }
          setTimeout(() => {
            this.goPriceModify()
          }, 800)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    goPriceModify() {
      this.openNewPage('AddReductionRecord', {
        serverUniqueId: this.$route.query.serverUniqueId,
        serverId: this.$route.query.serverId
      })
    },
    resetForm() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.line-text {
  margin-left: 10px;
}

.btns-bottom {
  margin-top: 15px;
  text-align: right;
}

.ml10 {
  margin-left: 10px;
}
</style>